export default __webpack_public_path__ + "img/birth.a3dca5db.svg";